module.exports = __webpack_public_path__ + "img/signature.5f28891.jpg";